import { Link } from 'react-router-dom';
import type { NewsArticle } from '@/types/news';
import { getCategoryName } from '@/mocks/news';
import { formatViews } from '@/utils/format';

export default function HotRanking({ articles }: { articles: NewsArticle[] }) {
  return (
    <ol className="flex flex-col">
      {articles.map((article, index) => (
        <li key={article.id}>
          <Link
            to={`/detail/${article.id}`}
            className="group flex items-start gap-3 border-b border-background-200 py-3 last:border-b-0"
          >
            <span
              className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-heading text-xs font-bold ${
                index < 3
                  ? 'bg-secondary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}
            >
              {index + 1}
            </span>
            <span className="min-w-0 flex-1">
              <span className="line-clamp-2 block text-sm font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                {article.title}
              </span>
              <span className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                <span>{getCategoryName(article.category)}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-fire-line text-secondary-500"></i>
                  {formatViews(article.views)}
                </span>
              </span>
            </span>
          </Link>
        </li>
      ))}
    </ol>
  );
}